import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import parse from 'html-react-parser'; 
import GLOBAL_CONFIG from '../../config/config'; 
import appGoogleTracking from '../../modules/googletracking';
import { mainLoaderToggle, navParticipationMenu, scrollToElement } from '../../modules/helpers';
import GiftContent from '../../components/Content/GiftContent/GiftContent';
import ValidateForm from '../../modules/validate';     
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import TitleContent from '../../components/Content/TitleContent/TitleContent';
import ReCaptcha from 'react-google-invisible-recaptcha';         
import _LOCAL_CAPTCHA from '../../Models/Captcha';
import GiftContentFooter from '../../components/Content/GiftContent/GiftContentFooter';
import CampaignServices from '../../Services/Campaign';

class ibanConfirm extends Component {
  //huhu

  constructor(props){
    super(props);
    this.state = {
      isMobile: false,
     
    };
    this.resize = this.resize.bind(this);
    

  }
  resize() {
    // set isMobile to true if the device is a mobile and false otherwise 
    this.setState({ isMobile: window.innerWidth <= 768 });
  }
    componentWillMount(){
      // if (sessionStorage.getItem(GLOBAL_CONFIG.Session.userstatus) === null) {
      //   //Go to particaption page
      //   this.props.history.push({ pathname: GLOBAL_CONFIG.Route.home });
      // }
      //    else {
      //   sessionStorage.removeItem(GLOBAL_CONFIG.Session.userinfo)
      //   }

      window.addEventListener("resize", this.resize);
      this.resize();
    }

    componentDidMount(){
        const { t } = this.props;
        //Active menu participation - mitmachen
        // navParticipationMenu(true);

        window.scrollTo(0, 0);
        //Remove main loader
        mainLoaderToggle('hide');


        //Virtual page
        appGoogleTracking.dataLayerPush({
            'customEvent': {
                'event': 'virtual-page',
                'virtualUri': GLOBAL_CONFIG.Route.thankyou,
                'pageTitle': t('Meta.title'),
                'ParticipantId' : window.PARTICIPATION_ID
            }
        });

    }

    componentWillUnmount(){
        mainLoaderToggle('show');
    }


    googleTag = (event, category, action, label) => {
      appGoogleTracking.dataLayerPush({
          'dataEvent': event,
          'dataCategory': category,
          'dataAction': action,
          'dataLabel': label
      })
  }


    render() { 
      console.log(this.props)
        const { t } = this.props;
        const { winTier, retailer } = this.state;
        console.log('winTier', winTier);
      let image = {
        desktop: t('Page.Confirmation.bottomBanner.desktop'),
        mobile: t('Page.Confirmation.bottomBanner.mobile')
      };  


        return (

          
          <div className={`content-iban content-confirmation__${window.PROMOTION_CAMPAIGN}`}>  
          {
                this.state.loaderSubmit ?
                    <div className="simple-loader__container active">
                        <div className="simple-loader__indicator"></div>
                    </div>
                    : null
            }
              <div className='confirmation-title'>
              <picture>
                  <source srcSet={parse(t('Page.Confirmation.title.desktop.iban'))} media='(min-width: 481px)'/>
                  <img src={parse(t('Page.Confirmation.title.mobile.iban'))} alt='win-title'/>
                </picture>
                <p className='confirmation-subtitle'>{parse(t('Page.IbanConfirmation.paragraph'))}</p>
              </div>

            <div className='redirection-iban'>
                <NavLink
                to={GLOBAL_CONFIG.Route.home}
                exact
                data-event="go_to_participation_form"
                data-category="Confirmation Refund Page"
                data-action="Click on Participation"
                data-label="ENG_CRP_OTHER"
                onClick={appGoogleTracking.processEventCTANavLink}
                >
                <div className="btn__container btn--primary btn--hover">
                <span className="btn__text">
                    ZUM Teilnahmeformular
                </span>
                </div>
            </NavLink>
              
            </div>
              <div className="content-participation-footer" style={{paddingTop: '0'}}>
              <div className="content-gift-footer">
      
                <div className="content-faq s-content-copy marge-bottom">
                    <div className="s-content-copy__item footer">
                        <p className="headings">HAST DU NOCH FRAGEN ZUM GEWINNSPIEL?</p>
                          <p style={{ fontSize: '20px', marginTop: '25px' }}>
                                <NavLink to={GLOBAL_CONFIG.Route.faq} target="_blank" exact data-event="upload_receipt_link" data-category="Confirmation Refund Page" data-action="Click on Link" data-label="GAME_CRP_PART" onClick={appGoogleTracking.processEventCTANavLink}>
                                    Hier
                                </NavLink> geht's zu den FAQ.
                            </p>
                    </div>
                </div>
            </div>
              </div>
          </div>

        );
    }

}

export default withTranslation()(ibanConfirm);
